export default "__VITE_PUBLIC_ASSET__9a970c5e__"